/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { AsyncPipe } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MatTableModule } from "@angular/material/table";
import { Cluster, ClusterColumn } from "../../../concept/cluster";
import { MatSortModule } from "@angular/material/sort";
import { ResourceTable, ResourceTableService } from "../../../service/resource-table.service";
import { ClusterStatusPipe } from "../cluster-status.pipe";
import { RegionPipe } from "../region.pipe";
import { DatetimePipe, MenuItem, SpinnerComponent } from "typedb-cloud-framework";
import {
    TableSelectionCellComponent,
    TableSelectionHeaderCellComponent,
} from "../../../framework/table";
import { Router } from "@angular/router";
import { spaceDetailsPath } from "../../../routing/resource-paths";
import { PartialWithId } from "../../../concept/base";
import { Space } from "../../../concept/space";
import { ApplicationState } from "../../../service/application-state.service";
import { AccessLevel } from "../../../concept/iam";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatButtonModule } from "@angular/material/button";
import { StatusIcon, StatusIndicatorComponent } from "../../../framework/status-indicator/status-indicator.component";
import { toSentenceCase } from "../../../util";

@Component({
    selector: "tp-clusters-table",
    templateUrl: "./clusters-table.component.html",
    imports: [
        AsyncPipe, DatetimePipe, MatTableModule, MatSortModule, MatMenuModule, MatTooltipModule, MatButtonModule,
        TableSelectionHeaderCellComponent, TableSelectionCellComponent, RegionPipe, ClusterStatusPipe, StatusIndicatorComponent, SpinnerComponent,
    ]
})
export class ClustersTableComponent {
    @Input({ required: true }) table!: ResourceTable<Cluster, ClusterColumn>;
    @Input() rowPopupMenuItems?: ((row: Cluster, access: AccessLevel) => MenuItem[]) | null;

    constructor(public tableService: ResourceTableService, private router: Router, private app: ApplicationState) {}

    clusterIcon(cluster: Cluster): StatusIcon {
        switch (cluster.status) {
            case "running":
                return "ok";

            case "starting":
            case "resuming":
            case "restoring":
            case "pausing":
            case "destroying":
            case "updatingTypeDB":
            case "reconfiguring":
            case "migrating":
                return "loading";

            case "paused":
            case "destroyed":
                return "inactive";
            case "error":
                return "error";
        }
    }

    openSpace(space: PartialWithId<Space>) {
        this.router.navigate([spaceDetailsPath(space, this.app.requireCurrentTeam())]);
    }

    protected readonly alert = alert;
    protected readonly toSentenceCase = toSentenceCase;
}
